export enum ReconciliationColumnFields {
  Status = 'status',
  DocumentId = 'documentId',
  PayableId = 'payableId',
  CardNumber = 'cardNumber',
  VendorId = 'vendorId',
  VendorName = 'vendorName',
  PayableAmount = 'paymentAmount',
  SettledAmount = 'settledAmount',
  PaymentDate = 'paymentDate',
  TransactionDate = 'transactionDate',
  SettledDate = 'settledDate',
  Void = 'void'
}
const RECONCILED = 'Reconciled';
const SETTLED = 'Settled';
const RECONCILIATIONSTATUS = 'reconciliationStatus';

export { RECONCILED, SETTLED, RECONCILIATIONSTATUS };
